<template>
      <div class="unauthorized-message">
        <h1 class="error-heading">Oops!</h1>
        <p class="error-message">You are not authorized to view this page.</p>
        <router-link to="/" @click="onClick" class="error-button">Go back to home page</router-link>
      </div>
</template>

<script>
import Header from './Header.vue'
import LeftMenu from './LeftMenu.vue'
import { mapActions } from 'vuex'
import { getLoggedSellerId, validateSellerIdAndToken, clearCookie, getCookie } from '../services/campaignService'

export default {
  name: 'App',
  components: {
    Header,
    LeftMenu,
  },
  methods: {
    ...mapActions(['setSellerId']),
    onClick(){
      let loggedUserId = getCookie('userId');
      this.setSellerId('');
      validateSellerIdAndToken(loggedUserId)
        .then(res => res.json())
        .then(data => {
            if (!!data?.token) {
              // valid token
            } else {
              // token expired so clear cookies
              clearCookie('token');
              clearCookie('sellerId');
              clearCookie('role');
              clearCookie('tncAcceptance');
              clearCookie('userEmail');
              clearCookie('userId');
              clearCookie('ipAddress');
              clearCookie('twoFactorRegistered');
              this.$router.go('/');
            }
        })
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: "Inter-Regular";
  src: url('../assets/fonts/Inter-Regular.ttf');
}

.unauthorized-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 15%;
}

.error-heading {
  font-family: "Inter-Regular";
  font-size: 32px;
  font-weight: bold;
  color: #F44336;
  margin-bottom: 20px;
}

.error-message {
  font-family: "Inter-Regular";
  font-size: 18px;
  color: #333333;
  margin-bottom: 40px;
  text-align: center;
}

.error-button {
  font-family: "Inter-Regular";
  font-size: 16px;
  color: #FFFFFF;
  background-color: #F44336;
  padding: 10px 20px;
  border-radius: 4px;
  text-decoration: none;
}

#app {

  font-family: "Inter-Regular";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


</style>
